import React from "react";
import { Navigate } from "react-router-dom";
import Layout from "../components/Layout";

function ProtectedRoute({ isAuthenticated, children }) {
  if (!isAuthenticated) {
    return <Navigate to={"/login"} />;
  }
  return <Layout />;
}

export default ProtectedRoute;
